import React from 'react';

const PostLabelIcon = (props) => {
    const {
        icon,
        label
    } = props;

    let labelIconTag = <div className="cpt-post-label">
        <span dangerouslySetInnerHTML={{ __html: icon }}></span>
        {label}
    </div>
    return labelIconTag;
}

export default PostLabelIcon;